import {useLocation} from "react-router-dom";
import {useMemo} from "react";

export const appOrigin = import.meta.env.VITE_APP_API_URL;

// @TODO clean base urls
export const routes: any = {
    base: "",
    api: {
        base: `${appOrigin}/api`,
        routes: {
            account: {
                base: "/accounts",
                routes: {
                    all: '/',
                    detail: '/{accountId}/',
                    billing: '/{accountId}/billing/',
                    plans: '/{accountId}/plans/',
                    addons: '/{accountId}/addons/',
                    onboard: '/onboard/',
                    businessProfile: '/{accountId}/business-profile/',
                    activities: {
                        base: '/{accountId}/activities',
                        routes: {
                            all: '/',
                        }
                    },
                    facebook: '/{accountId}/facebook/',
                    instagram: {
                        base: '/{accountId}/instagram',
                        routes: {
                            all: '/',
                            detail: '/{instagramId}/',
                        }
                    },
                    whatsapp: {
                        base: '/{accountId}/whatsapp',
                        routes: {
                            all: '/',
                            detail: '/{wabaId}/',
                            templates: {
                                base: '/{wabaId}/templates',
                                routes: {
                                    all: '/',
                                    detail: '/{templateId}/',
                                }
                            }
                        }
                    },
                    connectedApps: {
                        base: '/{accountId}/connected-apps',
                        routes: {
                            all: '/'
                        }
                    },
                    automationApps: {
                        base: '/{accountId}/automation-apps',
                        routes: {
                            all: '/'
                        }
                    },
                    automation: {
                        base: '/{accountId}/automation',
                        routes: {
                            all: '/',
                            detail: '/{automationId}/',
                            apps: '/apps/',
                            nodes: {
                                base: '/{automationId}/nodes',
                                routes: {
                                    all: '/',
                                    detail: '/{nodeId}/'
                                }
                            },
                            events: {
                                base: '/{automationId}/events',
                                routes: {
                                    all: '/',
                                    detail: '/{eventId}/'
                                }
                            },
                            actions: {
                                base: '/{automationId}/actions',
                                routes: {
                                    all: '/',
                                    detail: '/{actionId}/'
                                }
                            },
                            conditions: {
                                base: '/{automationId}/conditions',
                                routes: {
                                    all: '/',
                                    detail: '/{conditionId}/'
                                }
                            },
                        }
                    },
                    automationNodes: {
                        base: '/{accountId}/automation-nodes',
                        routes: {
                            all: '/',
                            detail: '/{nodeId}/',
                            availableActions: '/available-actions/'
                        }
                    },
                    automationEvents: {
                        base: '/{accountId}/automation-events',
                        routes: {
                            all: '/',
                            detail: '/{eventId}/',
                            availableEvents: '/available-events/'
                        }
                    },
                    authorizedRepresentatives: {
                        base: '/{accountId}/authorized-representatives',
                        routes: {
                            all: '/',
                            detail: '/{representativeId}/',
                        }
                    },
                    search: '/{accountId}/search/',
                    activity: '/{accountId}/activity/',
                    notifications: '/notifications/',
                    userAccountSettings: '/{accountId}/user-settings/',
                    subscription: '/{accountId}/subscription/',
                    alert: {
                        base: "/{accountId}/alerts",
                        routes: {
                            all: '/',
                            detail: '/{alertId}/',
                            dismiss: '/{alertId}/dismiss/'
                        }
                    },
                    chatbot: {
                        base: "/{accountId}/chatbot",
                        routes: {
                            all: '/',
                            detail: '/{chatId}/',
                            prompt: '/{chatId}/prompt/',
                            messages: {
                                base: "/{chatId}/messages",
                                routes: {
                                    all: '/',
                                    detail: '/{messageId}/'
                                }
                            }
                        }
                    },
                    tasksDefinition: {
                        base: '/{accountId}/tasks-definition',
                        routes: {
                            all: '/',
                            detail: '/{taskId}/',
                            move: '/{taskId}/move/',
                        }
                    },
                    flagDefinitions: {
                        base: '/{accountId}/flag-definitions',
                        routes: {
                            all: '/',
                            detail: '/{flagId}/',
                            move: '/{flagId}/move/',
                        }
                    },
                    documentTemplates: {
                        base: "/{accountId}/document-templates",
                        routes: {
                            all: '/',
                            detail: '/{templateId}/'
                        }
                    },
                    documentFiles: {
                        base: "/{accountId}/document-files",
                        routes: {
                            all: '/',
                            detail: '/{fileId}/'
                        }
                    },
                    listView: {
                        base: '/{accountId}/list-view/{objectType}',
                        routes: {
                            all: '/',
                            detail: '/{viewId}/'
                        }
                    },
                    lead: {
                        base: "/{accountId}/leads",
                        routes: {
                            all: "/",
                            detail: "/{objectId}/",
                            tasks: {
                                base: '/{objectId}/tasks',
                                routes: {
                                    all: '/',
                                    detail: '/{taskId}/',
                                    createInitial: '/create-initial-tasks/',
                                    toggle: '/{taskId}/toggle/',
                                }
                            },
                            deal: {
                                base: '/{leadId}/deals',
                                routes: {
                                    all: '/',
                                    detail: '/{dealId}/'
                                }
                            },
                            emails: {
                                base: '/{leadId}/emails',
                                routes: {
                                    all: '/',
                                    detail: '/{emailId}/'
                                }
                            },
                            sms: {
                                base: '/{objectId}/sms',
                                routes: {
                                    all: '/',
                                    detail: '/{smsId}/',
                                }
                            },
                            bulkUpdate: '/bulk-update/',
                            calls: {
                                base: '/{objectId}/calls',
                                routes: {
                                    detail: '/{callId}/',
                                    requestTranscript: '/{callId}/request-transcript/',
                                    getTranscript: '/{callId}/get-transcript/',
                                    all: '/',
                                }
                            },
                            documents: {
                                base: '/{objectId}/documents',
                                routes: {
                                    all: '/',
                                    detail: '/{documentId}/'
                                }
                            },
                            visitedPages: {
                                base: '/{objectId}/visited-pages',
                                routes: {
                                    all: '/',
                                }
                            }
                        }
                    },
                    deal: {
                        base: "/{accountId}/deals",
                        routes: {
                            all: "/",
                            detail: "/{objectId}/",
                            updateDocumentStage: '/{dealId}/update-contract-stage/',
                            updateDocumentSigner: '/{dealId}/update-contract-signer/',
                            makePayment: "/{dealId}/make_payment/",
                            allPaymentsReceipts: "/{dealId}/print-all-payments-receipts?showAll={showAll}",
                            balanceVerified: "/{dealId}/mark-balance-verified/",
                            sendPublicLink: "/{dealId}/send-public-link/",
                            createPublicLink: "/{dealId}/create-public-link/",
                            applyCoupon: "/{dealId}/apply-coupon/{couponId}/",
                            removeCoupon: "/{dealId}/remove-coupon/{couponId}/",
                            toggleApprove: "/{dealId}/toggle-approve/",
                            requestApproval: "/{dealId}/request-approval/",
                            orderItems: {
                                base: "/{dealId}/order_items",
                                routes: {
                                    all: '/',
                                    detail: '/{orderItemId}/'
                                }
                            },
                            payments: {
                                base: "/{dealId}/payments",
                                routes: {
                                    all: '/',
                                    refundPayment: "/{paymentId}/refund/",
                                    markDisputed: "/{paymentId}/mark-disputed/",
                                    changeOrder: "/{paymentId}/change-order/",
                                    getReceipt: "/{paymentId}/print-payment-receipt/",
                                    detail: "/{paymentId}/"
                                }
                            },
                            bulkUpdate: '/bulk-update/',
                            restoreProducts: "/{dealId}/restore-last-signed/",
                            cancel: '/{dealId}/cancel-deal/',
                            documents: {
                                base: '/{objectId}/documents',
                                routes: {
                                    all: '/',
                                    detail: '/{documentId}/'
                                }
                            }
                        }
                    },
                    chats: {
                        base: '/{accountId}/chat',
                        routes: {
                            all: '/',
                            detail: '/{conversationId}/',
                            messages: {
                                base: '/{conversationId}',
                                routes: {
                                    all: '/messages/'
                                }
                            },
                            availableAgents: '/{conversationId}/available-agents/'
                        }
                    },
                    chatWidgets: {
                        base: '/{accountId}/chat-widgets',
                        routes: {
                            all: '/',
                            detail: '/{chatId}/',
                            contentSchema: '/content-schema/',
                            agents: {
                                base: '/{chatId}/agents',
                                routes: {
                                    all: '/',
                                    detail: '/{agentId}/',
                                    move: '/{agentId}/move/',
                                    bulkAdd: '/bulk-add/'
                                }
                            },
                            formFields: {
                                base: '/{chatId}/form-fields',
                                routes: {
                                    all: '/',
                                    detail: '/{fieldId}/',
                                    move: '/{fieldId}/move/'
                                }
                            }
                        }
                    },
                    formSubmissions: {
                        base: "/{accountId}/chat-widgets/{formId}/form-submissions",
                        routes: {
                            all: '/',
                            detail: '/{submissionId}/'
                        }
                    },
                    payment: {
                        base: "/{accountId}/payments",
                        routes: {
                            all: '/',
                            refundPayment: "/{paymentId}/refund/",
                            markDisputed: "/{paymentId}/mark-disputed/",
                            changeOrder: "/{paymentId}/change-order/",
                            detail: '/{objectId}/'
                        }
                    },
                    paymentMethods: {
                        base: "/{accountId}/payment-methods",
                        routes: {
                            all: '/',
                        }
                    },
                    stripeDashboardUrl: "/{accountId}/stripe-dashboard-url/",
                    patient: {
                        base: "/{accountId}/patients",
                        routes: {
                            all: "/",
                            detail: "/{objectId}/",
                            deal: {
                                base: '/{patientId}/deals',
                                routes: {
                                    all: '/',
                                    detail: '/{dealId}/'
                                }
                            },
                            flags: '/{patientId}/flags/',
                            tasks: {
                                base: '/{objectId}/tasks',
                                routes: {
                                    all: '/',
                                    detail: '/{taskId}/',
                                    createInitial: '/create-initial-tasks/',
                                    toggle: '/{taskId}/toggle/',
                                }
                            },
                            emails: {
                                base: '/{patientId}/emails',
                                routes: {
                                    all: '/',
                                    detail: '/{emailId}/'
                                }
                            },
                            appointments: {
                                base: '/{patientId}/appointments',
                                routes: {
                                    all: '/',
                                    detail: '/{appointmentId}',
                                }
                            },
                            sms: {
                                base: '/{objectId}/sms',
                                routes: {
                                    all: '/',
                                    detail: '/{smsId}/',
                                }
                            },
                            calls: {
                                base: '/{objectId}/calls',
                                routes: {
                                    detail: '/{callId}/',
                                    requestTranscript: '/{callId}/request-transcript/',
                                    getTranscript: '/{callId}/get-transcript/',
                                    all: '/',
                                }
                            },
                            bulkUpdate: '/bulk-update/',
                            portalInvite: '/{patientId}/send-portal-invite/',
                            findExisting: '/{patientId}/find-existing-user/',
                            linkExisting: '/{patientId}/link-existing-user/',
                            pictures: {
                                base: '/{patientId}/pictures',
                                routes: {
                                    all: '/',
                                    detail: '/{pictureId}/'
                                }
                            },
                            documents: {
                                base: '/{objectId}/documents',
                                routes: {
                                    all: '/',
                                    detail: '/{documentId}/'
                                }
                            },
                            demographics: {
                                base: '/{objectId}/demographics',
                                routes: {
                                    all: '/',
                                    detail: '/{demographicsId}/'
                                }
                            },
                            pharmacies: {
                                base: '/{objectId}/pharmacies',
                                routes: {
                                    all: '/',
                                    detail: '/{pharmacyId}/',
                                    search: '/search/'
                                }
                            },
                            prescriptions: {
                                base: '/{objectId}/prescriptions',
                                routes: {
                                    all: '/',
                                    detail: '/{prescriptionId}/',
                                }
                            },
                            allergies: {
                                base: '/{objectId}/allergies',
                                routes: {
                                    all: '/',
                                    detail: '/{allergyId}/',
                                    search: '/search/'
                                }
                            },

                        }
                    },
                    sms: {
                        base: '/{accountId}/sms',
                        routes: {
                            all: '/',
                            detail: '/{smsId}/',
                        }
                    },
                    conversations: {
                        base: '/{accountId}/conversations',
                        routes: {
                            all: '/',
                            detail: '/{conversationId}/'
                        }
                    },
                    emails: {
                        base: "/{accountId}/emails",
                        routes: {
                            all: '/',
                            detail: '/{emailId}/'
                        }
                    },
                    properties: {
                        base: "/{accountId}/properties",
                        routes: {
                            detail: "/{objectType}/"
                        }
                    },
                    propertyGroups: {
                        base: "/{accountId}/property-groups/{objectType}",
                        routes: {
                            all: "/"
                        }
                    },
                    accountProperties: {
                        base: "/{accountId}/account-properties/{objectType}",
                        routes: {
                            all: "/",
                            detail: "/{propertyId}/",
                        }
                    },
                    locations: {
                        base: "/{accountId}/locations",
                        routes: {
                            all: "/",
                            detail: "/{locationId}/"
                        }
                    },
                    paymentProviders: {
                        base: "/{accountId}/payment-providers",
                        routes: {
                            all: "/",
                            detail: "/{providerId}/",
                            signup: "/signup/"
                        }
                    },
                    productLibrary: {
                        base: "/{accountId}/product_library",
                        routes: {
                            all: "/",
                            detail: "/{productLibraryPk}",
                            product: {
                                base: "/{productLibraryPk}/product",
                                routes: {
                                    all: "/",
                                    detail: "/{productPk}/"
                                }
                            },
                            coupons: {
                                base: "/{productLibraryId}/coupons",
                                routes: {
                                    all: "/",
                                    detail: "/{couponId}/",
                                }
                            },
                            rules: {
                                base: "/{productLibraryId}/rules",
                                routes: {
                                    all: "/",
                                    detail: "/{ruleId}/",
                                }
                            }
                        }
                    },
                    associations: {
                        base: "/{accountId}/associations",
                        routes: {
                            all: '/',
                            detail: '/{associationId}/'
                        }
                    },
                    calls: {
                        base: "/{accountId}/calls",
                        routes: {
                            all: '/',
                            detail: '/{callId}/'
                        }
                    },
                    phoneCall: {
                        base: '/{accountId}/calls',
                        routes: {
                            detail: '/{objectId}/',
                            all: '/',
                        }
                    },
                    users: {
                        base: "/{accountId}/users",
                        routes: {
                            all: '/',
                            detail: '/{userId}/',
                        }
                    },
                    accountUserRemove: {
                        base: "/{accountId}/remove-user",
                        routes: {
                            detail: '/{userId}/'
                        }
                    },
                    invitations: {
                        base: "/{accountId}/invitations",
                        routes: {
                            all: '/',
                            detail: '/{inviteId}/',
                        }
                    },
                    invite: {
                        base: "/{accountId}/invite",
                        routes: {
                            add: '/add/',
                            resend: '/resend/',
                            accept: '/accept/',
                            delete: '/delete/',
                            detail: '/',
                        }
                    },
                    teams: {
                        base: "/{accountId}/teams",
                        routes: {
                            all: '/',
                            detail: '/{teamId}/',
                            add: '/{teamId}/add/',
                            remove: '/{teamId}/remove/'
                        }
                    },
                    file: {
                        base: "/{accountId}/files",
                        routes: {
                            all: "/",
                            detail: "/{fileId}/"
                        }
                    },
                    charts: {
                        base: "/{accountId}/charts",
                        routes: {
                            all: "/",
                            detail: "/{chartId}/"
                        }
                    },
                    publicFile: {
                        base: "/{accountId}/public-files",
                        routes: {
                            all: "/",
                            detail: "/{fileId}/"
                        }
                    },
                    documents: {
                        base: "/{accountId}/documents",
                        routes: {
                            all: "/",
                            detail: "/{documentId}/"
                        }
                    },
                    documentPreview: {
                        base: "/{accountId}",
                        routes: {
                            preview: '/document-preview/'
                        }
                    },
                    appointments: {
                        base: "/{accountId}/appointments",
                        routes: {
                            all: '/',
                            detail: '/{appointmentId}/',
                            print: '/print/',
                            invite: '/{appointmentId}/invite/',
                            labOrders: {
                                base: '/{appointmentId}/lab-orders',
                                routes: {
                                    all: '/',
                                    detail: '/{orderId}/',
                                    print: '/{orderId}/print-order/'
                                }
                            },
                            labOrderResults: {
                                base: '/{appointmentId}/lab-order-results',
                                routes: {
                                    all: '/',
                                    detail: '/{labResultId}/',
                                }
                            }
                        }
                    },
                    appointmentGuests: {
                        base: '/{accountId}/appointment-guests',
                        routes: {
                            all: '/',
                            detail: '/{guestId}/',
                        }
                    },
                    appointmentRooms: {
                        base: "/{accountId}/appointment-rooms",
                        routes: {
                            all: '/',
                            detail: '/{roomId}/'
                        }
                    },
                    appointmentColors: {
                        base: "/{accountId}/appointment-colors",
                        routes: {
                            all: '/',
                            detail: '/{colorId}/',
                            move: '/{colorId}/move/'
                        }
                    },
                    medicalDiagnosis: '/{accountId}/diagnoses-query/',
                    labTests: '/{accountId}/lab-tests/',
                    providerBlocks: {
                        base: "/{accountId}/provider-blocks",
                        routes: {
                            all: '/',
                            detail: '/{blockId}/'
                        }
                    },
                    providers: {
                        base: "/{accountId}/providers",
                        routes: {
                            all: '/',
                            detail: '/{providerId}/',
                            providerBlocks: {
                                base: "/{providerId}/provider-blocks",
                                routes: {
                                    all: '/',
                                    detail: '/{blockId}/'
                                }
                            },
                        }
                    },
                    appointmentSettings: {
                        base: "/{accountId}/appointment-settings",
                        routes: {
                            all: '/',
                            detail: '/{settingId}/'
                        }
                    },
                    contractConnection: {
                        base: "/{accountId}/contract-connection",
                        routes: {
                            all: '/',
                            detail: '/{connectionId}/'
                        }
                    },
                    phoneProvider: {
                        base: "/{accountId}/phone-provider",
                        routes: {
                            all: '/',
                            detail: '/{providerId}/',
                            users: '/{providerId}/users/',
                            syncSMS: '/{providerId}/sync-sms/',
                            realTimeSyncSMS: '/{providerId}/real-time-sync-extension-sms/{extensionId}/',
                            connectUser: '/{providerId}/connect-user/',
                            twilio: {
                                base: '/twilio',
                                routes: {
                                    onboard: '/onboard/',
                                    submit: '/onboard/submit/',
                                    brand: '/brand/',
                                }
                            },
                            messagingService: {
                                base: '/{providerId}/messaging-service',
                                routes: {
                                    all: '/',
                                    detail: '/{messagingServiceId}/',
                                    assignPhone: '/{messagingServiceId}/assign-phone/',
                                    removePhone: '/{messagingServiceId}/remove-phone/'
                                }
                            },
                            phoneNumbers: {
                                base: '/{providerId}/phone-numbers',
                                routes: {
                                    all: '/',
                                    detail: '/{phoneId}/'
                                }
                            },
                        }
                    },
                    voiceIntegrity: {
                        base: "/{accountId}/voice-integrity",
                        routes: {
                            all: '/',
                            detail: '/{voiceIntegrityId}/',
                        }
                    },
                    phoneNumbers: {
                        base: '/{accountId}/phone-numbers',
                        routes: {
                            all: '/',
                            detail: '/{phoneId}/'
                        }
                    },
                    whatsAppNumber: {
                        base: '/{accountId}/whatsapp-numbers',
                        routes: {
                            all: '/',
                            detail: '/{phoneId}/'
                        }
                    },
                    twilioProvider: {
                        base: "/{accountId}/twilio-provider",
                        routes: {
                            detail: '/',
                            pkDetail: '/{twilioProviderId}/',
                            availablePhoneNumbers: '/available-phone-numbers/',
                            buyPhoneNumber: '/buy-phone-number/',
                            phoneNumbers: {
                                base: '/{twilioProviderId}/phone-numbers',
                                routes: {
                                    all: '/',
                                    detail: '/{phoneId}/'
                                }
                            },
                            users: {
                                base: '/{twilioProviderId}/users',
                                routes: {
                                    all: '/',
                                    detail: '/{userId}/'
                                }
                            },
                            callGroups: {
                                base: '/{twilioProviderId}/call-groups',
                                routes: {
                                    all: '/',
                                    detail: '/{groupId}/',
                                    groupAgents: {
                                        base: '/{groupId}/agents',
                                        routes: {
                                            all: '/',
                                            detail: '/{agentId}/'
                                        }
                                    }
                                }
                            },

                        }
                    },
                    emailChannels: {
                        base: "/{accountId}/email-channels",
                        routes: {
                            all: '/',
                            detail: '/{channelId}/',
                            thread: '/{channelId}/thread/{emailId}/',
                            testSmtp: '/test-smtp-configuration/',
                            testImap: '/test-imap-configuration/',
                            conversations: {
                                base: '/{channelId}/conversations',
                                routes: {
                                    all: '/',
                                    messages: '/{conversationId}/'
                                }
                            },
                        }
                    },
                    channels: {
                        base: "/{accountId}/channels",
                        routes: {
                            all: '/',
                            conversations: '/{key}/{channelId}/',
                            messages: '/{key}/{channelId}/{conversationId}/',
                            conversationDetail: '/{key}/{channelId}/{conversationId}/detail/',
                        }
                    },
                    import: {
                        base: "/{accountId}/import",
                        routes: {
                            parser: '/parse/',
                            doImport: '/do_import/',
                            all: '/',
                            validate: '/validate/',
                        }
                    },
                    export: {
                        base: "/{accountId}/export",
                        routes: {
                            all: '/',
                        }
                    },
                    appImport: {
                        base: "/{accountId}/app-import",
                        routes: {
                            all: '/',
                            detail: '/{appId}/',
                            doImport: '/{appId}/start-import/'
                        }
                    },
                    emailTemplate: {
                        base: "/{accountId}/email-templates",
                        routes: {
                            all: '/',
                            detail: '/{templateId}/',
                            move: '/{templateId}/move/'
                        }
                    },
                    emailActions: {
                        base: "/{accountId}/email",
                        routes: {
                            tags: '/tags/',
                            renderTemplate: '/render/',
                            send: '/send/'
                        }
                    },
                    labOrderTemplates: {
                        base: "/{accountId}/lab-order-templates",
                        routes: {
                            all: '/',
                            detail: '/{orderTemplateId}/'
                        }
                    },
                    emailCampaignTemplates: {
                        base: "/{accountId}/email-campaign-templates",
                        routes: {
                            all: '/',
                            detail: '/{templateId}/',
                            move: '/{templateId}/move/',
                        }
                    },
                    emailCampaignSettings: {
                        base: "/{accountId}/email-campaign-settings",
                        routes: {
                            all: '/',
                            detail: '/{settingsId}/',
                        }
                    },
                    smsCampaignSettings: {
                        base: "/{accountId}/sms-campaign-settings",
                        routes: {
                            all: '/',
                            detail: '/{settingsId}/',
                        }
                    },
                    emailCampaigns: {
                        base: "/{accountId}/email-campaigns",
                        routes: {
                            all: '/',
                            detail: '/{campaignId}/',
                        }
                    },
                    smsCampaigns: {
                        base: "/{accountId}/sms-campaigns",
                        routes: {
                            all: '/',
                            detail: '/{campaignId}/',
                        }
                    },
                    emailCampaignEvents: {
                        base: "/{accountId}/email-campaigns/{campaignId}/email-campaign-events",
                        routes: {
                            all: '/',
                            detail: '/{eventId}/',
                            clickRank: '/click-rank/'
                        }
                    },
                    adAccount: {
                        base: "/{accountId}/ad-account",
                        routes: {
                            all: '/',
                            detail: '/{adAccountId}/',
                            availableGoogleAdAccounts: '/get-available-google-accounts/',
                            availableFacebookAdAccounts: '/get-available-facebook-accounts/',
                            insights: '/{adAccountId}/insights/',
                            adGroup: {
                                base: "/{adAccountId}/ad-group",
                                routes: {
                                    all: '/'
                                }
                            }
                        }
                    }
                }
            },
            perfectomyCampaignTemplates: {
                base: "/perfectomy-campaign-templates",
                routes: {
                    all: '/',
                }
            },
            publicFolders: {
                base: "/public-folders",
                routes: {
                    detail: '/{folderId}/'
                }
            },
            settings: {
                base: "",
                routes: {
                    permissions: "/permissions/",
                    accountSettings: "/accounts/{accountId}/settings/",
                }
            },
            featureReleases: {
                base: "/features-release",
                routes: {
                    all: '/'
                }
            },
            integrator: {
                base: "/integrator",
                routes: {
                    all: "/{accountId}/",
                    add: "/{accountId}/{appName}/"
                }
            },
            notifications: {
                base: "/notifications",
                routes: {
                    all: '/',
                    detail: '/{notificationId}/',
                    markAllRead: '/mark-all-read/',
                }
            },
            portal: {
                base: "/portal",
                routes: {
                    profiles: {
                        base: "/profiles",
                        routes: {
                            all: "/",
                            detail: "/{profileId}/"
                        }
                    },
                    deals: {
                        base: "/deals",
                        routes: {
                            all: "/",
                            detail: "/{dealId}/",
                            createPolicy: "/{dealId}/create-policy/",
                            appointments: "/{dealId}/appointments/",
                        }
                    },
                    payments: {
                        base: "/payments/{dealId}",
                        routes: {
                            all: "/"
                        }
                    },
                    labOrder: {
                        base: "/lab-order/{appointmentId}",
                        routes: {
                            all: '/',
                        }
                    },
                    linkProfile: '/link-profile/{profileLinkId}/',
                    publicDeal: '/public-deal/{dealId}/',
                    profile: '/profile/'
                }
            },
            payments: {
                base: "/payments",
                routes: {
                    publicPayment: "/public-payment/",
                    tokens: {
                        base: "/tokens",
                        routes: {
                            all: '/',
                            detail: '/{token}/'
                        }
                    },
                    pay: "/pay/"
                }
            },
            campaigns: {
                base: "/campaigns",
                routes: {
                    unsubscribe: "/unsubscribe/{campaignToken}/{subscriberToken}/"
                }
            },
        }
    },
    basicAuth: {
        base: `${appOrigin}/accounts/auth`,
        routes: {
            login: "/login/",
            logout: "/logout/",
            refreshToken: "/token/refresh/",
            socialLogin: "/social/{provider}/",
            signup: "/signup/",
            user: "/user/",
            resetPassword: "/password/reset/confirm/",
            forgotPassword: "/password/reset/",
            register: "/registration/",
            resendVerificationEmail: "/registration/resend-email/",
            verifyEmail: "/registration/verify-email/",
        }
    },
    oauth: {
        base: `${appOrigin}/accounts/oauth`,
        routes: {
            authorize: '/authorize/',
        }
    },
    chat: {
        base: `${import.meta.env.VITE_APP_CHAT_URL}/api`,
        routes: {
            init: '/init/{widgetReference}/',
            token: '/init/{widgetReference}/{visitorId}/token/',
            messages: '/init/{widgetReference}/{conversation}/',
            conversations: {
                base: '/conversations/{widgetReference}/{visitorId}',
                routes: {
                    all: '/',
                    token: '/{conversationId}/token/',
                    detail: '/{conversationId}/'
                }
            },
            attachments: {
                base: '/{roomId}/attachment',
                routes: {
                    all: '/',
                    detail: '/{attachmentId}/'
                }
            },
            rooms: '/rooms/{widgetReference}/{visitorId}'
        }
    },
    frontend: {
        base: "",
        routes: {
            ehr: {
                base: "/accounts",
                routes: {
                    account: {
                        base: "",
                        routes: {
                            all: "/",
                            dashboard: '/{accountId}/dashboard/',
                            adInsights: {
                                base: '/{accountId}/adinsights',
                                routes: {
                                    all: '/',
                                    detail: '/{adAccountId}/',
                                }
                            },
                            record: {
                                base: "/{accountId}/records/{objectType}",
                                routes: {
                                    all: "/",
                                    detail: "/{objectId}/"
                                }
                            },
                            appointment: {
                                base: "/{accountId}/appointments",
                                routes: {
                                    all: "/",
                                    detail: "/{appointmentId}",
                                }
                            },
                            import: {
                                base: "/{accountId}/import",
                                routes: {
                                    all: '/',
                                    fileImport: '/file-import/',
                                }
                            },
                            emailTemplate: {
                                base: "/{accountId}/email-templates",
                                routes: {
                                    all: '/'
                                }
                            },
                            fileViewer: {
                                base: "/{accountId}/file-viewer",
                                routes: {
                                    detail: "/{attachmentId}/"
                                }
                            },
                            inbox: {
                                base: "/{accountId}/inbox",
                                routes: {
                                    channel: {
                                        base: '/channel',
                                        routes: {
                                            conversations: '/{channelId}/',
                                            conversation: '/{channelId}/conversation/{conversationId}/'
                                        }
                                    }
                                }
                            },
                            reports: "/{accountId}/reports/",
                            reportExplorer: "/{accountId}/reports-explorer/",
                            chat: {
                                base: "/{accountId}/chat",
                                routes: {
                                    all: '/',
                                    detail: '/{chatId}/',
                                    conversations: {
                                        base: '/conversation',
                                        routes: {
                                            all: '/',
                                            detail: '/{conversationId}/'
                                        }
                                    }
                                }
                            },
                            channels: {
                                base: "/{accountId}/channels",
                                routes: {
                                    detail: "/{key}/{channelId}/",
                                    messages: "/{key}/{channelId}/{conversationId}/"
                                }
                            },
                            exports: {
                                base: "/{accountId}/exports",
                                routes: {
                                    all: "/"
                                }
                            },
                            campaigns: {
                                base: "/{accountId}/campaigns",
                                routes: {
                                    all: '/',
                                    calendar: '/calendar/',
                                    templates: '/templates/',
                                    emailEditor: '/email-editor/{campaignId}/',
                                    smsEditor: '/sms-editor/{campaignId}/',
                                    smsReport: '/sms-campaign-summary/{campaignId}/',
                                    emailSummary: '/email-campaign-summary/{campaignId}/',
                                }
                            },
                            savedViews: {
                                base: "/{accountId}/saved-views",
                                routes: {
                                    all: '/',
                                    view: '/view/{objectType}/{viewId}/'
                                }
                            },
                            formSubmissions: {
                                base: "/{accountId}/forms",
                                routes: {
                                    all: '/',
                                    detail: '/{formId}/',
                                    submission: '/{formId}/'
                                }
                            }
                        }
                    },
                    productLibrary: {
                        base: "/{accountId}/product-libraries",
                        routes: {
                            all: '/',
                            detail: '/{productLibraryId}/{tab}/',
                            coupons: {
                                base: '/{productLibraryId}/coupons',
                                routes: {
                                    detail: '/{couponId}/'
                                }
                            }
                        }
                    },
                    settings: {
                        base: "/{accountId}/settings",
                        routes: {
                            all: '/',
                            general: '/general',
                            users: '/users',
                            account: '/account/{tab}/',
                            documents: '/documents',
                            integrations: '/integrations',
                            phoneProvider: {
                                base: '/phoneProvider',
                                routes: {
                                    all: '/',
                                    detail: '/{phoneProviderId}/',
                                    twilioNew: '/twilio/new/',
                                    tab: '/{phoneProviderId}/{tab}/',
                                    callGroups: '/{phoneProviderId}/general-settings/call-groups/{groupId}/',
                                    user: '/{phoneProviderId}/users/user/{userId}/'
                                }
                            },
                            perfectomyPhoneGroup: '/perfectomy-phone/{providerId}/call-groups/{groupId}/',
                            providers: '/providers/',
                            providerBlocks: '/providers/provider/{providerId}/',
                            appointmentSettings: '/appointment-settings/{tab}/',
                            appointmentRooms: '/appointment-rooms',
                            emailChannels: '/emailChannels',
                            appImport: '/app-import',
                            labOrderTemplates: '/lab-order-templates',
                            payments: '/payments',
                            documentTemplates: '/documents',
                            chatWidgets: {
                                base: '/chat-widgets',
                                routes: {
                                    all: '/',
                                    detail: '/chats/{chatId}/'
                                }
                            },
                            facebook: {
                                base: '/facebook',
                                routes: {
                                    all: '/',
                                    onboard: '/settings/onboard/',
                                    whatsapp: '/whatsapp/{wabaId}/'
                                }
                            },
                            adAccounts: {
                                base: '/ad-accounts',
                                routes: {
                                    all: '/',
                                    detail: '/{adAccountId}/',
                                    googleAds: '/connect/google-ads/',
                                    facebookAds: '/connect/facebook-ads/',
                                }
                            },
                            whatsapp: {
                                base: '/whatsapp',
                                routes: {
                                    onboard: '/onboard/',

                                }
                            },
                            locationSettings: '/location-settings',
                            billing: '/billing',
                            objectTasks: '/object-tasks',
                            patients: '/patient-settings/{tab}/',
                            campaigns: '/campaign-settings/{tab}/'
                        }
                    },
                    onboard: {
                        base: "/onboard",
                        routes: {
                            start: '/'
                        }
                    },
                    forms: {
                        base: "/{accountId}/forms",
                        routes: {
                            all: '/',
                            detail: '/{formId}/'
                        }
                    }
                }
            },
            auth: {
                base: "/auth",
                routes: {
                    login: "/login/",
                    register: "/register/",
                    signup: "/signup/",
                    resetPassword: "/reset-password/",
                    forgotPassword: "/forgot-password/"
                }
            },
            portal: {
                base: "/portal",
                routes: {
                    home: '/bookings/',
                    userProfile: "/user-profile/",
                    profiles: {
                        base: "/profiles",
                        routes: {
                            all: '/',
                            detail: '/{profileId}/',
                        }
                    },
                    linkProfile: "/link-profile/"
                }
            },
            facebookConnect: "/facebook/connect/"
        }
    }
};

/*
    Construct full route based on a params dict
    of expected arguments. For instance, to get blueprint.all route @params
    should be:
    {
       id: "something"
    }
 */


export const getRoute = (routeRequest: string, params?: any) => {
    let keys = routeRequest.split(".");
    let currentRoute = routes;
    let route = currentRoute.base;

    keys.forEach((key, index) => {
        if (currentRoute.hasOwnProperty(key)) {
            if (currentRoute[key].hasOwnProperty("routes")) {
                route += currentRoute[key].base;
                currentRoute = currentRoute[key].routes;
            } else {
                let final = currentRoute[key];
                route += final;
            }
        } else if (index < keys.length - 1) {
            throw new Error(`Invalid route: ${routeRequest}`)
        }
    });

    for (let param in params) {
        if (params.hasOwnProperty(param)) {
            route = route.replace(`{${param}}`, params[param]);
        }
    }

    return route
};


export function useQuery() {
    const {search} = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}